import React from "react";
import CardHighlightFeatImage from "../../cards/cardHighlightFeatImage";

const SupportSafety = ({ supportDetails }) => {
  return (
    <>
      <div className={""}>
        <h2 className="heading text-left py-5">
          {supportDetails.supportAndSafetyTitle}
        </h2>
        <div className="divide-y width-divider" />
        <div
          className={
            "dark:gvi-light-gray-text text-generic-text  text-sm pt-10 pb-0 tab-content_html"
          }
          dangerouslySetInnerHTML={{
            __html: supportDetails.supportAndSafetyContent
          }}
        />

        <div className="grid gap-6 grid-flow-row auto-rows-max dark:gvi-light-gray-text text-sm my-6">
          <CardHighlightFeatImage
            key={"safety"}
            title={"Safety"}
            desc={supportDetails.programSafetyContent}
            featuredImage={supportDetails?.safetyImage?.localFile}
            sourceUrl={supportDetails?.safetyImage?.sourceUrl}
            url={supportDetails?.supportAndSafetyProtocols}
            ctaTitle={"View support and safety protocols"}
            titleExtraClasses={"font-body font-medium"}
            readMoreRotate={"rotate-180"}
          />

          <CardHighlightFeatImage
            key={"support"}
            title={"Support"}
            desc={supportDetails.programSupportContent}
            featuredImage={supportDetails?.supportImage}
            sourceUrl={supportDetails?.supportImage?.sourceUrl}
            ctaTitle={"View risk mitigation"}
            url={supportDetails.supportAndSafetyProtocols}
            titleExtraClasses={"font-body font-medium"}
            readMoreRotate={"rotate-180"}
          />
        </div>

        <h3 className="heading text-left py-10 text-xl font-normal text-black-lighter">
          Health and safety case studies
        </h3>
        {supportDetails.healthAndSafetyCaseStudies && (
          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 dark:gvi-light-gray-text text-sm pt-4">
            {supportDetails.healthAndSafetyCaseStudies.map((caseStudy, idx) => (
              <CardHighlightFeatImage
                key={`$case-study-${idx}`}
                title={caseStudy.caseStudyTitle}
                featuredImage={caseStudy?.caseStudyImage}
                sourceUrl={caseStudy?.caseStudyImage?.sourceUrl}
                desc={caseStudy.caseStudyExcerpt}
                titleExtraClasses={"font-body font-medium"}
                readMoreStatus={"hidden"}
              />
            ))}
          </div>
        )}
      </div>
    </>
  );
};

export default SupportSafety;
